import ClassenService from '../ClassenService';

class DecorService {
  getDecors() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/decors`);
  }

  addDecor(decorData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/decors`, 'addDecor', decorData);
  }

  getDecor(decorId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/decors/${decorId}`);
  }

  getDecorQuickSelection(decorId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/decors/${decorId}/quickselections`);
  }

  updateDecor(decorId, decorData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/decors/${decorId}`, 'updateDecor', decorData);
  }

  deleteDecor(decorId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/decors/${decorId}`, 'deleteDecor');
  }

  searchDecors(page = 1, size = 16, searchData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/decors/search?page[size]=${size}&page[number]=${page}`, 'searchData', searchData);
  }

  getDecorsFacets() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/decors/facets`);
  }

  addDecorAsset(decorId, assetData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/decors/${decorId}/asset`, 'addDecorAsset', assetData);
  }

  updateDecorAsset(decorId, assetId, assetData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/decors/${decorId}/asset/${assetId}`, 'updateDecorAsset', assetData);
  }

  deleteDecorAsset(decorId, assetId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/decors/${decorId}/asset/${assetId}`, 'deleteDecorAsset');
  }

  addSearchDecorsToSelection(searchData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/decors/addSearchToSelection`, 'addAllToSelection', searchData);
  }

  removeSearchFromSelection(searchData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/decors/removeSearchFromSelection`, 'removeSearchFromSelection', searchData);
  }
}

export default new DecorService();
